import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const titleStyle = {
  marginBottom: '12.5px',
};

export const formContainerStyle = {
  maxWidth: '504px',
  minWidth: '504px',
};

export const selectBoxStyle = (color: string | undefined): SystemStyleObject<Theme> => {
  if (color) {
    return {
      '.MuiInputBase-input': {
        textTransform: 'capitalize',
        color: `${color} !important`,
        '> span.Mui-placeholder': {
          color: color,
        },
      },
    };
  }

  return {} as SystemStyleObject<Theme>;
};

export const cellSelectBoxStyle = {
  '.MuiFormControl-root': {
    marginTop: '0',
  },
};
